"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.string.replace.js");

var template;

function createMacroMap(macro, value) {
  var obj = {};
  obj[macro] = value;
  return obj;
}

var _default = {
  setTemplate: function setTemplate(errorMessageTemplate) {
    template = errorMessageTemplate;
  },
  macroToValue: function macroToValue(msg, macro, value) {
    var reg = new RegExp("{".concat(macro, "}"), 'g');
    return msg.replace(reg, value);
  },
  get: function get(name, templateData) {
    var msg = template[name];

    if (!msg) {
      throw Error("can't get the value of errorMessageTemplate['".concat(name, "']"));
    }

    if (arguments.length === 1) {
      return msg;
    }

    if ((0, _typeof2["default"])(templateData) !== 'object') {
      templateData = createMacroMap(name, templateData);
    }

    for (var macro in templateData) {
      msg = this.macroToValue(msg, macro, templateData[macro]);
    }

    return msg;
  }
};
exports["default"] = _default;